/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_GInputs */

const en_tut_oscari_g = /** @type {(inputs: Tut_Oscari_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once the office is busy, stop circling the map. Search instead.`)
};

const id_tut_oscari_g = /** @type {(inputs: Tut_Oscari_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau kantor sudah ramai, jangan memutari peta. Cari saja.`)
};

/**
* | output |
* | --- |
* | "Once the office is busy, stop circling the map. Search instead." |
*
* @param {Tut_Oscari_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_g = /** @type {((inputs?: Tut_Oscari_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_g(inputs)
	return en_tut_oscari_g(inputs)
});